//POST/api/v1/martingale  body={max_attempts}
//GET/api/martingale/latest

const API_URL = process.env.REACT_APP_API_URL;

const getAuthHeader = () => {
    const token = localStorage.getItem('token');
    return {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
    };
};

export async function setMartingale(max_attempts) {
    const response = await fetch(`${API_URL}/api/v1/martingale`, {
        method: 'POST',
        headers: getAuthHeader(),
        body: JSON.stringify({ max_attempts })
    });
    return response;
}

export async function getLatestMartingale() {
    const response = await fetch(`${API_URL}/api/v1/martingale/latest`, {
        method: 'GET',
        headers: getAuthHeader()
    });
    return response;
}
